<template>

    <div class="containerBox">
        <div class="zxkc_tile">科研与教学成果</div>
        <div class="zxkc_content">
            <div class="zxkc_content_left">
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '教学课题' ? 'zxkc_content_left_item_active' : ''" @click="changeType('教学课题')">教学课题
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '教学获奖' ? 'zxkc_content_left_item_active' : ''" @click="changeType('教学获奖')">教学获奖
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '学术获奖' ? 'zxkc_content_left_item_active' : ''" @click="changeType('学术获奖')">学术获奖
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '论文著作' ? 'zxkc_content_left_item_active' : ''" @click="changeType('论文著作')">论文著作
                </div>


            </div>
            <div class="zxkc_content_center"></div>
            <div class="zxkc_content_right_type2" v-if="type == '教学课题'">
                <div  class="zxkc_content_right_ppt"  v-if="listShow.length > 0" >
                    <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow" >
                        <div class="zxkc_content_right_ppt_item_text">
                            <div class="zxkc_content_right_ppt_item_text_left_unactive" :class="item.active == true ? 'zxkc_content_right_ppt_item_text_left' : ''"  @mouseover="item.active = true"
                            @mouseleave="item.active = false" @click="toDetail(item)">{{ item.title }}</div>
                            <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)" >在线预览>></div>
                        </div>
                        <div class="zxkc_content_right_ppt_item_line">
                        </div>
                    </div>
                    <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>
            </div>
            <div class="zxkc_content_right_type2" v-if="type == '教学获奖'">
                <div  class="zxkc_content_right_ppt"  v-if="listShow.length > 0" >
                    <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow" >
                        <div class="zxkc_content_right_ppt_item_text">
                            <div class="zxkc_content_right_ppt_item_text_left_unactive" :class="item.active == true ? 'zxkc_content_right_ppt_item_text_left' : ''"  @mouseover="item.active = true"
                            @mouseleave="item.active = false" @click="toDetail(item)">{{ item.title }}</div>
                            <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)" >在线预览>></div>
                        </div>
                        <div class="zxkc_content_right_ppt_item_line">
                        </div>
                    </div>
                    <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>
            </div>
            <div class="zxkc_content_right_type2" v-if="type == '学术获奖'">
                <div  class="zxkc_content_right_ppt"  v-if="listShow.length > 0" >
                    <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow" >
                        <div class="zxkc_content_right_ppt_item_text">
                            <div class="zxkc_content_right_ppt_item_text_left_unactive" :class="item.active == true ? 'zxkc_content_right_ppt_item_text_left' : ''"  @mouseover="item.active = true"
                            @mouseleave="item.active = false" @click="toDetail(item)">{{ item.title }}</div>
                            <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)" >在线预览>></div>
                        </div>
                        <div class="zxkc_content_right_ppt_item_line">
                        </div>
                    </div>
                    <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 40%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>
            </div>
            <div class="zxkc_content_right_type2" v-if="type == '论文著作'">
                <div  class="zxkc_content_right_ppt"  v-if="listShow.length > 0" >
                    <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow" >
                        <div class="zxkc_content_right_ppt_item_text">
                            <div class="zxkc_content_right_ppt_item_text_left_unactive" :class="item.active == true ? 'zxkc_content_right_ppt_item_text_left' : ''"  @mouseover="item.active = true"
                            @mouseleave="item.active = false" @click="toDetail(item)">{{ item.title }}</div>
                            <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)" >在线预览>></div>
                        </div>
                        <div class="zxkc_content_right_ppt_item_line">
                        </div>
                    </div>
                    <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { url } from '../services/url'
import {
    getKycgList
} from "../services/services";
export default {
    name: 'Index',
    data() {
        return {
            type: '教学课题',
            total: 1,
            pageSize: 9,
            pageNum: 1,
            listShow: [],
            userId:localStorage.getItem('userId'),
            getUrl: url
        }
    },
    created() {
        const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
        getKycgList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
            this.total = res.total
            this.listShow = res.rows
            console.log(res)
            loading.close()
        })
        if(this.$route.query.item!=undefined){
            if(this.$route.query.item.id!=undefined){
                this.toDetail(this.$route.query.item)
            }
        }
    },
    methods: {
        changeType(type) {
            this.pageNum = 1
            this.type = type
            getKycgList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
                console.log(res)
                loading.close()

            }).catch(err => {
                loading.close()

            })

        },
        pageChange(e) {
            this.pageNum = e
            getKycgList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
            }).catch(err => {

            })
        },
        toDetail(item) {
            if ((item.fileUrl == null || item.fileUrl == '') && (item.outUrl == null || item.outUrl == '')) {
                this.$message({
						message: '当前没有资源',
						type: 'warning'
					});
                return

            }
            else if (item.outUrl != null && item.outUrl != '') {
                window.open(item.outUrl, "_blank")
            }
            else{
                window.open(this.getUrl + item.fileUrl, "_blank")
                // this.$router.push({
                //         path: '/ViewPpt',
                //         query: {
                //             url: this.getUrl + item.fileUrl
                //         }
                //     });
            }
        }
    },
}
</script>
<style>
/* 或者本地文件 */
@import url('../css/style.css');
</style>